var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMenuMarketTrackerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint0_linear_1350_3364)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1350_3364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint1_linear_1350_3364)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1350_3364)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.2666,
    y: -6.16943,
    width: 113.967,
    height: 87.2542,
    rx: 3.48092,
    fill: "#EBD3D3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8786 38.431C42.879 40.9893 41.2168 43.547 37.8929 45.4987C34.5688 47.4502 30.2124 48.4259 25.8559 48.4263C21.4991 48.4259 17.1425 47.4502 13.8187 45.4987C10.4949 43.5472 8.83288 40.9895 8.83276 38.4316C8.83266 35.8736 10.4946 33.3157 13.8186 31.364C17.1428 29.4123 21.4991 28.4366 25.8556 28.4366C30.212 28.4366 34.5688 29.4123 37.8929 31.364C41.2166 33.3155 42.8783 35.8733 42.8786 38.431Z",
    fill: "#F1F1F6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2538 40.4954H25.8562V42.457H29.2538V40.4954Z",
    fill: "#C4CAE9"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M43.7759 41.7985H29.8513V44.7051H43.7759V41.7985Z",
    fill: "url(#paint2_linear_1350_3364)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M51.8696 28.1461H36.542L39.0674 43.6847H51.8696V28.1461Z",
    fill: "url(#paint3_linear_1350_3364)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8103 31.8186C41.8099 29.4214 40.2526 27.0241 37.1374 25.1953C34.0222 23.3662 29.9389 22.4517 25.8557 22.4517C21.7727 22.4514 17.6897 23.366 14.5742 25.1953C11.4588 27.0243 9.90125 29.4219 9.90137 31.8192H14.45C14.4498 30.1054 15.5634 28.3915 17.7906 27.0839C20.0177 25.7761 22.9368 25.1221 25.8557 25.1223C28.7748 25.1223 31.6939 25.7761 33.9209 27.0839C36.1479 28.3912 37.2614 30.1049 37.2615 31.8189H41.8103V31.8186Z",
    fill: "#5652CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 31.8191H9.90137V38.4309H14.45V31.8191Z",
    fill: "#362E94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9209 27.0839C31.6939 25.776 28.7748 25.1223 25.8557 25.1223C22.9368 25.1221 20.0177 25.776 17.7906 27.0839C15.5634 28.3915 14.4498 30.1054 14.45 31.8192V38.4315C14.4498 36.7176 15.5634 35.0038 17.7906 33.6961C20.0177 32.3884 22.9368 31.7346 25.8557 31.7348C28.7748 31.7348 31.6939 32.3884 33.9209 33.6961C34.5999 34.0854 35.2242 34.5661 35.7768 35.1251C36.7662 34.103 37.2618 32.961 37.2615 31.8188C37.2614 30.1049 36.1479 28.3912 33.9209 27.0839Z",
    fill: "url(#paint4_linear_1350_3364)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9943 25.207H14.45V38.4311H18.9943V25.207Z",
    fill: "#423EAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2615 25.2065C37.2614 23.4927 36.1479 21.779 33.9209 20.4714C31.6939 19.1639 28.7748 18.51 25.8557 18.51C22.9368 18.5099 20.0177 19.1637 17.7906 20.4714C15.5634 21.7791 14.4498 23.4929 14.45 25.207H18.9943C18.9943 24.1759 19.6641 23.1448 21.0039 22.3582C22.3439 21.5715 24.0999 21.1782 25.8559 21.1783C27.6118 21.1783 29.368 21.5716 30.7078 22.3582C32.0475 23.1448 32.7173 24.1757 32.7174 25.2067V25.207H37.2615V25.2065Z",
    fill: "#807DFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7076 22.3583C29.3678 21.5717 27.6117 21.1783 25.8558 21.1783C24.0997 21.1782 22.3437 21.5716 21.0038 22.3583C19.664 23.1449 18.9941 24.1759 18.9941 25.207V38.4311C18.9941 37.3999 19.664 36.3689 21.0038 35.5823C22.3437 34.7954 24.0997 34.4024 25.8558 34.4024C26.6634 34.4012 27.4689 34.4869 28.2588 34.6583V28.9803C29.1517 28.7846 29.9896 28.4771 30.7076 28.0557C32.0472 27.2691 32.7171 26.2381 32.7173 25.2071V25.2068C32.7171 24.1757 32.0473 23.1449 30.7076 22.3583Z",
    fill: "url(#paint5_linear_1350_3364)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.164 17.089H23.5474V21.0403H28.164V17.089Z",
    fill: "url(#paint6_linear_1350_3364)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7043 15.7478C29.3655 14.9616 27.6105 14.5686 25.8558 14.5686C24.1008 14.5685 22.3459 14.9615 21.0068 15.7478C19.6681 16.5338 18.9987 17.564 18.9985 18.5944H23.5476C23.5476 18.2475 23.7729 17.9007 24.2236 17.6362C24.6743 17.3715 25.265 17.2392 25.8558 17.2392C26.4463 17.2392 27.0371 17.3715 27.4878 17.6362C27.9385 17.9007 28.1639 18.2475 28.164 18.5944H32.7128C32.7127 17.5641 32.0432 16.5338 30.7043 15.7478Z",
    fill: "#FFD03E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5473 20.5254V18.5942H18.9985V38.431H21.917V21.8894L23.5473 20.5254Z",
    fill: "#E19100"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5474 11.9819V38.4312C23.5474 38.7779 23.7727 39.1249 24.2234 39.3892C24.674 39.654 25.2648 39.7864 25.8557 39.7864C26.4461 39.7864 27.0369 39.654 27.4876 39.3892C27.9383 39.1248 28.1636 38.778 28.1638 38.4312V11.9819H23.5474Z",
    fill: "url(#paint7_linear_1350_3364)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4876 11.0238C27.0369 10.7592 26.4461 10.6268 25.8556 10.6268C25.2648 10.6268 24.6741 10.7591 24.2234 11.0238C23.7727 11.2884 23.5474 11.6352 23.5474 11.982C23.5474 12.3289 23.7727 12.6757 24.2234 12.9404C24.674 13.2049 25.2648 13.3372 25.8557 13.3372C26.4461 13.3372 27.0369 13.2049 27.4876 12.9404C27.9383 12.6757 28.1638 12.3288 28.1638 11.982C28.1636 11.6351 27.9383 11.2884 27.4876 11.0238Z",
    fill: "#FFAF6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.713 18.5944C32.713 19.6249 32.0435 20.6551 30.7045 21.4414C29.3657 22.2274 27.6109 22.6205 25.8561 22.6205C24.4753 22.6205 23.0954 22.3761 21.9172 21.8895V38.4311V41.7263C23.0954 42.2128 24.4753 42.4571 25.8561 42.4572C27.6109 42.4571 29.3657 42.0642 30.7045 41.2781C32.0436 40.4919 32.713 39.4615 32.713 38.4311V18.5944Z",
    fill: "url(#paint8_linear_1350_3364)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1642 18.5944C28.1642 18.9412 27.9387 19.2881 27.488 19.5527C27.0373 19.8173 26.4465 19.9496 25.8561 19.9496C25.4027 19.9538 24.9528 19.8703 24.5301 19.7036L21.9172 21.8895C23.0954 22.3761 24.4753 22.6205 25.8561 22.6205C27.6109 22.6205 29.3657 22.2274 30.7045 21.4414C32.0435 20.6551 32.713 19.6249 32.713 18.5944H28.1642Z",
    fill: "#FFD03E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.9448 16.7408H28.1643V18.5943C28.1643 18.9411 27.9388 19.288 27.4881 19.5527C27.0374 19.8173 26.4466 19.9496 25.8562 19.9496H32.3142C32.5695 19.5448 32.7077 19.0752 32.7131 18.5943C32.713 17.9572 32.4566 17.3203 31.9448 16.7408Z",
    fill: "url(#paint9_linear_1350_3364)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8514 44.705L28.2588 42.2046V28.9802L29.8514 31.4805V44.705Z",
    fill: "#5652CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7173 25.2074C32.7172 26.2385 32.0473 27.2693 30.7077 28.0561C29.9897 28.4775 29.1517 28.785 28.2588 28.9807L29.8514 31.481C31.3354 31.1556 32.7276 30.6431 33.9208 29.9425C36.1477 28.6349 37.2614 26.9213 37.2614 25.2074H32.7173Z",
    fill: "#807DFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9207 29.9421C32.7275 30.6427 31.3353 31.1552 29.8513 31.4806V44.7051C31.3353 44.3799 32.7275 43.8672 33.9207 43.1666C36.1479 41.8589 37.2616 40.145 37.2613 38.431V25.2065C37.2616 26.9206 36.1479 28.6345 33.9207 29.9421Z",
    fill: "url(#paint10_linear_1350_3364)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.9208 20.4715C33.5312 20.2443 33.1294 20.0394 32.7173 19.858V25.207C32.7172 26.2381 32.0473 27.269 30.7077 28.0557C29.9897 28.4771 29.1517 28.7846 28.2588 28.9803H35.2799C36.6005 27.8461 37.2614 26.5268 37.2614 25.207V25.2066C37.2613 23.4928 36.1477 21.779 33.9208 20.4715Z",
    fill: "url(#paint11_linear_1350_3364)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2617 31.819C37.2619 33.1318 36.6077 34.4445 35.3008 35.5746L39.0675 37.0726C40.8955 35.4915 41.8106 33.6555 41.8104 31.819H37.2617Z",
    fill: "#5652CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0675 43.6842L35.3008 42.1863V35.5746L39.0675 37.0725V43.6842Z",
    fill: "#20196F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0671 37.0726V43.6848C40.8952 42.1038 41.8104 40.2678 41.8101 38.4311V31.8193C41.8099 33.656 40.8949 35.4917 39.0671 37.0726Z",
    fill: "#131147"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M37.2617 25.27V31.8189C37.2619 33.1318 36.6077 34.4445 35.3008 35.5746H40.475C41.3649 34.3806 41.8105 33.0999 41.8104 31.8189V31.8187C41.8101 29.4537 40.2934 27.0895 37.2617 25.27Z",
    fill: "url(#paint12_linear_1350_3364)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1399 18.212L51.9478 16.576L50.7559 19.6117L51.2759 19.3063V24.6167L52.6198 23.8276V18.5174L53.1399 18.212Z",
    fill: "url(#paint13_linear_1350_3364)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2598 -3.28095L22.4874 -5.71362L20.7148 -1.19956L21.4881 -1.6537V6.2426L23.4865 5.06932V-2.82699L24.2598 -3.28095Z",
    fill: "url(#paint14_linear_1350_3364)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.628 6.64747L42.7244 5.40735L41.8208 7.70857L42.2151 7.47701V11.5025L43.2338 10.9044V6.87891L43.628 6.64747Z",
    fill: "url(#paint15_linear_1350_3364)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6438 13.3085L10.5729 11.8387L9.50195 14.566L9.96912 14.2917V19.0625L11.1764 18.3536V13.5828L11.6438 13.3085Z",
    fill: "url(#paint16_linear_1350_3364)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.8557 12.1867H28.135C28.1734 12.0537 28.1736 11.9123 28.1354 11.7793H25.8557V12.1867Z",
    fill: "url(#paint17_linear_1350_3364)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8557 6.32799C26.7794 5.38876 28.0276 5.83355 28.8831 5.27331C29.7136 4.72931 30.0051 3.72212 31.7054 3.37439C30.727 3.99254 30.1806 5.56891 28.997 6.77243C27.9891 7.79743 26.6563 7.60135 25.8557 8.63184V6.32799Z",
    fill: "url(#paint18_linear_1350_3364)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5073 5.99939V11.9819C25.5101 12.013 25.5211 12.0429 25.539 12.0683C25.557 12.0937 25.5812 12.1138 25.6094 12.1265C25.6857 12.166 25.7701 12.1865 25.8557 12.1865C25.9414 12.1865 26.0258 12.166 26.1021 12.1265C26.1303 12.1138 26.1545 12.0937 26.1725 12.0683C26.1904 12.0429 26.2014 12.013 26.2042 11.9819V5.99939H25.5073Z",
    fill: "url(#paint19_linear_1350_3364)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1021 5.85482C26.0258 5.81544 25.9414 5.79492 25.8558 5.79492C25.7701 5.79492 25.6857 5.81544 25.6094 5.85482C25.5796 5.86506 25.5538 5.88453 25.5355 5.91049C25.5172 5.93644 25.5073 5.96758 25.5073 5.99952C25.5073 6.03147 25.5172 6.0626 25.5355 6.08856C25.5538 6.11452 25.5796 6.13399 25.6094 6.14423C25.6857 6.18361 25.7701 6.20413 25.8558 6.20413C25.9414 6.20413 26.0258 6.18361 26.1021 6.14423C26.1319 6.13399 26.1577 6.11452 26.176 6.08856C26.1943 6.0626 26.2042 6.03147 26.2042 5.99952C26.2042 5.96758 26.1943 5.93644 26.176 5.91049C26.1577 5.88453 26.1319 5.86506 26.1021 5.85482Z",
    fill: "#807DFB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M54.6071 35.1681H50.5784L52.2107 36.1266L50.5784 37.0851H54.6071L56.2395 36.1266L54.6071 35.1681Z",
    fill: "url(#paint20_linear_1350_3364)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6433 31.6637L53.2758 32.6222V35.1682L51.6433 34.2097V31.6637Z",
    fill: "#5652CC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2758 30.7052L51.6433 31.6637L53.2758 32.6222L54.9083 31.6637L53.2758 30.7052Z",
    fill: "#6B67E9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9458 34.1298L50.5784 35.0882V37.0851L48.9458 36.1266V34.1298Z",
    fill: "#FCBA06"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2107 34.1298L50.5784 35.0882V37.0851L52.2107 36.1266V34.1298Z",
    fill: "#E19100"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5784 33.1713L48.9458 34.1298L50.5784 35.0883L52.2108 34.1298L50.5784 33.1713Z",
    fill: "#FFD03E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5512 -1.9264C48.5511 -1.53146 48.276 -1.04683 47.9397 -0.849385L39.0736 4.35618C38.7374 4.55362 38.4622 4.39212 38.4622 3.99718V1.84315C38.4622 1.44833 38.7374 0.963575 39.0736 0.766135L47.9397 -4.43943C48.276 -4.63687 48.5511 -4.47525 48.5512 -4.08043V-1.9264Z",
    fill: "#FFD03E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1855 1.20004C42.289 1.14027 42.3708 1.04806 42.4186 0.937157C42.4702 0.81568 42.4963 0.684622 42.4953 0.552324C42.4606 0.6155 42.4195 0.674801 42.3727 0.729257C42.3228 0.790249 42.2628 0.841986 42.1956 0.882169C42.0889 0.94475 41.9996 0.95558 41.9275 0.914659C41.8554 0.873756 41.8194 0.784318 41.8193 0.646341C41.8206 0.504119 41.861 0.365102 41.936 0.245033C42.0074 0.121875 42.1085 0.0192232 42.2297 -0.0532641C42.4202 -0.16516 42.5519 -0.142527 42.6246 0.0146353C42.6693 0.126187 42.6902 0.246125 42.6859 0.366513C42.6875 0.495203 42.6744 0.623645 42.6467 0.749243C42.6243 0.850723 42.5882 0.948578 42.5395 1.04005C42.4647 1.18649 42.352 1.30937 42.2135 1.39544C42.0847 1.47104 41.9681 1.49217 41.8637 1.45883L41.9641 1.22598C41.9976 1.23828 42.0336 1.24189 42.0688 1.2365C42.1098 1.23304 42.1496 1.2206 42.1855 1.20004ZM42.222 0.658845C42.2916 0.617601 42.3506 0.560046 42.3939 0.490969C42.4372 0.427937 42.4612 0.353315 42.4629 0.27647C42.4662 0.248426 42.4617 0.219994 42.45 0.194393C42.4383 0.168792 42.4197 0.147045 42.3964 0.131617C42.3695 0.119575 42.3399 0.115119 42.3107 0.118717C42.2815 0.122315 42.2538 0.133835 42.2305 0.152069C42.1629 0.192229 42.1065 0.249114 42.0663 0.317432C42.0253 0.381459 42.0029 0.455946 42.0016 0.532344C41.9983 0.559974 42.0019 0.588013 42.0122 0.613816C42.0225 0.639619 42.039 0.662336 42.0603 0.679824C42.0994 0.706175 42.1533 0.699181 42.222 0.658845ZM43.0077 0.732237C42.927 0.648324 42.8867 0.496423 42.8867 0.27653C42.8838 0.0707176 42.9251 -0.133258 43.0077 -0.32117C43.0831 -0.493966 43.2106 -0.637846 43.3719 -0.731943C43.5342 -0.827247 43.6557 -0.832895 43.7361 -0.748888C43.8168 -0.664983 43.8571 -0.513081 43.857 -0.293181C43.8599 -0.0873801 43.8187 0.116594 43.7361 0.304515C43.6607 0.477317 43.5331 0.621194 43.3719 0.715292C43.2096 0.81059 43.0882 0.816238 43.0077 0.732237ZM43.1514 -0.256718C43.1025 -0.122618 43.0786 0.0195714 43.0808 0.162588C43.0808 0.31848 43.1043 0.43059 43.1514 0.498919C43.1986 0.567227 43.272 0.572039 43.3719 0.513354C43.474 0.452014 43.5515 0.355883 43.5907 0.241991C43.6387 0.10771 43.662 -0.0343919 43.6596 -0.177253C43.6596 -0.334437 43.6366 -0.447189 43.5907 -0.515512C43.5447 -0.583763 43.4718 -0.588593 43.3719 -0.530003C43.2692 -0.467954 43.1912 -0.371243 43.1514 -0.256718ZM44.4733 -1.2857C44.4996 -1.2641 44.5201 -1.23608 44.5329 -1.20425C44.5457 -1.17243 44.5503 -1.13783 44.5464 -1.10369C44.5446 -1.00897 44.5191 -0.916284 44.4724 -0.834319C44.4307 -0.75104 44.367 -0.681187 44.2885 -0.632553C44.2153 -0.589544 44.1544 -0.584694 44.1056 -0.618003C44.0793 -0.639554 44.0587 -0.667545 44.0459 -0.699356C44.0331 -0.731168 44.0285 -0.765762 44.0324 -0.799903C44.0342 -0.894637 44.0597 -0.987342 44.1065 -1.06927C44.1482 -1.15258 44.2118 -1.22248 44.2903 -1.27115C44.3635 -1.3141 44.4245 -1.31895 44.4733 -1.2857ZM45.166 -1.75134L44.2945 0.157561L44.0749 0.286522L44.9465 -1.62244L45.166 -1.75134ZM44.3592 -0.888834C44.377 -0.925168 44.3863 -0.965174 44.3864 -1.00576C44.3881 -1.02106 44.3863 -1.03654 44.3813 -1.05108C44.3763 -1.06561 44.3682 -1.07883 44.3576 -1.08978C44.3474 -1.09757 44.3349 -1.10173 44.3222 -1.10163C44.3094 -1.10152 44.297 -1.09715 44.2869 -1.0892C44.2564 -1.06976 44.2323 -1.04139 44.2179 -1.0078C44.2001 -0.971445 44.1908 -0.931421 44.1906 -0.890821C44.189 -0.875514 44.1907 -0.860026 44.1957 -0.845496C44.2007 -0.830965 44.2089 -0.817762 44.2196 -0.806856C44.2298 -0.799024 44.2422 -0.794834 44.255 -0.79494C44.2678 -0.795045 44.2802 -0.799439 44.2903 -0.807439C44.3208 -0.826855 44.3448 -0.855235 44.3592 -0.888834ZM45.149 -0.872824C45.1753 -0.85127 45.1958 -0.823288 45.2086 -0.79149C45.2214 -0.759693 45.2261 -0.725118 45.2222 -0.690988C45.2205 -0.596262 45.195 -0.503554 45.1482 -0.421614C45.1065 -0.338277 45.0429 -0.268364 44.9644 -0.219674C44.8912 -0.176727 44.8302 -0.171936 44.7814 -0.205302C44.7551 -0.226826 44.7345 -0.254802 44.7217 -0.286608C44.7089 -0.318413 44.7043 -0.353004 44.7082 -0.387138C44.71 -0.48186 44.7355 -0.574561 44.7822 -0.656511C44.824 -0.739827 44.8876 -0.809732 44.9661 -0.858451C45.0393 -0.9014 45.1003 -0.906191 45.149 -0.872824ZM45.0385 -0.474142C45.0562 -0.510439 45.0655 -0.550412 45.0656 -0.590951C45.0673 -0.606258 45.0655 -0.621749 45.0605 -0.636281C45.0555 -0.650813 45.0473 -0.664015 45.0366 -0.674916C45.0265 -0.682762 45.014 -0.686977 45.0013 -0.686903C44.9885 -0.68683 44.9762 -0.682472 44.9661 -0.674508C44.9356 -0.655013 44.9115 -0.626604 44.8971 -0.592996C44.8793 -0.556643 44.87 -0.516619 44.8699 -0.476018C44.8682 -0.460727 44.87 -0.445251 44.875 -0.430737C44.88 -0.416222 44.8882 -0.403041 44.8989 -0.392164C44.909 -0.384312 44.9215 -0.380102 44.9343 -0.380186C44.9471 -0.38027 44.9594 -0.384644 44.9695 -0.39263C45 -0.412162 45.024 -0.440561 45.0385 -0.474142Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "#81AE21",
    fillOpacity: 0.79
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1350_3364",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1350_3364",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1350_3364",
    x1: 29.8513,
    y1: 43.2518,
    x2: 43.7759,
    y2: 43.2518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#D7DBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1350_3364",
    x1: 36.542,
    y1: 35.9155,
    x2: 51.8696,
    y2: 35.9155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#D3D7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EBEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1350_3364",
    x1: 14.4499,
    y1: 31.7769,
    x2: 37.2615,
    y2: 31.7769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D88B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9B3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1350_3364",
    x1: 18.9942,
    y1: 29.8047,
    x2: 32.7173,
    y2: 29.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9543D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8744B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1350_3364",
    x1: 23.5474,
    y1: 19.0647,
    x2: 28.164,
    y2: 19.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76B24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B893D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1350_3364",
    x1: 23.5474,
    y1: 25.8842,
    x2: 28.1638,
    y2: 25.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC3153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1350_3364",
    x1: 21.9172,
    y1: 30.5257,
    x2: 32.713,
    y2: 30.5257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1350_3364",
    x1: 25.8562,
    y1: 18.3452,
    x2: 32.7131,
    y2: 18.3452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7DBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1350_3364",
    x1: 29.8513,
    y1: 34.9558,
    x2: 37.2613,
    y2: 34.9558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362E94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1350_3364",
    x1: 28.2588,
    y1: 24.4192,
    x2: 37.2614,
    y2: 24.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#CED2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#E8E9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1350_3364",
    x1: 35.3008,
    y1: 30.4223,
    x2: 41.8104,
    y2: 30.4223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#D5D9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1350_3364",
    x1: 51.9479,
    y1: 24.2221,
    x2: 48.6094,
    y2: 18.5362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1350_3364",
    x1: 22.4873,
    y1: 5.65599,
    x2: 17.523,
    y2: -2.79882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1350_3364",
    x1: 42.7244,
    y1: 11.2035,
    x2: 40.1937,
    y2: 6.89326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1350_3364",
    x1: 10.5729,
    y1: 18.7079,
    x2: 7.57363,
    y2: 13.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1350_3364",
    x1: 25.8557,
    y1: 11.983,
    x2: 28.1639,
    y2: 11.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7DBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1350_3364",
    x1: 25.8557,
    y1: 6.00313,
    x2: 31.7054,
    y2: 6.00313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1350_3364",
    x1: 25.5073,
    y1: 9.09292,
    x2: 26.2042,
    y2: 9.09292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B67E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20196F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1350_3364",
    x1: 50.5784,
    y1: 36.1266,
    x2: 56.2395,
    y2: 36.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#DDE0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#F6F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuMarketTrackerIcon);
export default __webpack_public_path__ + "static/media/newMenuMarketTrackerIcon.a42972610f6b99b1b4c688bc021ffc9e.svg";
export { ForwardRef as ReactComponent };